export default __webpack_public_path__ + "static/media/leadBundle.8bf23d44.svg";